import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_WORKSPACE_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/onboarding/status-integracao`;
export default{
    async listar(){
        return await Vue.prototype.$httpJson.get(baseUrl);
    }  
}